import React from 'react';
import { Grid, Stack, Theme, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import roles from 'config/roles/roles';
import useCheckRoles from 'hooks/useCheckRoles';
import Link from 'common/Link/Link';
import { subscriptionAlertHeightRem } from 'config/material-ui/dimensions';
import DangerHexagonIcon from 'assets/icons/DangerHexagonIcon';

export default function CancelledSubscriptionAlert() {
  const { t } = useTranslation();
  const isAdmin = useCheckRoles(roles.admin);
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  return (
    <Grid
      item
      xs={12}
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      <Stack
        alignItems="center"
        justifyContent="space-between"
        direction="row"
        p={{
          xs: 1,
          md: 3,
        }}
        bgcolor="background.error"
        height={`${subscriptionAlertHeightRem}rem`}
      >
        <Stack spacing={2} direction="row" alignItems="center">
          <DangerHexagonIcon sx={{ color: 'error.main', fontSize: '2.2rem' }} />
          <Stack spacing={0.5}>
            {isAdmin && (
              <Typography
                color="error.alert"
                variant={isMobile ? 'body2' : 'body1'}
              >
                {t('subscription.unable_process_payment')}
              </Typography>
            )}
            <Typography
              variant={isMobile ? 'caption' : 'body2'}
              color="error.alert"
            >
              {t(
                isAdmin
                  ? 'subscription.unable_payment_description'
                  : 'subscription.subscription_has_been_cancelled',
              )}
            </Typography>
          </Stack>
        </Stack>
        {isAdmin && (
          <Link
            variant={isMobile ? 'caption' : 'buttonSmall'}
            to="/settings?tab=subscriptionAndPayments"
            sx={{
              color: 'error.alert',
              textDecoration: 'none',
            }}
          >
            {t('settings.edit_payment_method')}
          </Link>
        )}
      </Stack>
    </Grid>
  );
}
